export default "__VITE_ASSET__fd9c3b5b__"